<div class="relative isolate h-full w-full flex flex-col p-2 sm:p-8">
    <div class="w-full h-full flex flex-col gap-y-2 sm:gap-y-4 items-start overflow-hidden">
        <div aria-hidden="true"
            class="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl">
            <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                class="aspect-1097/845 w-274.25 bg-linear-to-tr from-[#ff4694] to-[#776fff] opacity-20"></div>
        </div>

        <div
            class="w-full min-h-0 flex flex-col items-center justify-start px-4 sm:px-6 flex-1 overflow-y-auto scrollbar-transparent relative">


            <div
                class="my-6 p-4 mx-auto h-16 w-16 rounded-full bg-linear-to-br from-primary to-brand-agency-dark text-white flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-10">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
            </div>

            <h2
                class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-center sm:text-left">
                Welcome to
                <span class="bg-linear-to-r from-brand-agency to-brand-studio bg-clip-text text-transparent">SHOUT!</span>
                🚀
            </h2>
            <p class="mx-auto mt-2 max-w-xl text-base sm:text-lg/8 text-pretty text-secondary text-center sm:text-left">
                Your subscription is confirmed and your 14-day trial has begun.</p>



            <div class="w-full max-w-7xl flex flex-col gap-y-6 py-6 sm:py-8 items-center">

                @if (currentUserService.currentSubscription()?.status === 'trialing') {
                <!-- Trial Card -->
                <div
                    class="flex items-start gap-4 w-full max-w-lg rounded-lg bg-green-50 inset-ring inset-ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:inset-ring-green-500/20 px-5 py-4">
                    <div
                        class="shrink-0 w-11 h-11 rounded-[10px] bg-white/10 dark:bg-green-400/10 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-6 h-6 text-green-500" aria-hidden="true">
                            <path d="M8 2v4" />
                            <path d="M16 2v4" />
                            <rect width="18" height="18" x="3" y="4" rx="2" />
                            <path d="M3 10h18" />
                        </svg>
                    </div>
                    <div class="min-w-0 flex flex-col gap-1">
                        <p class="text-base font-semibold leading-tight text-green-500 m-0">Your Free Trial is Active
                        </p>
                        <p class="text-[0.9375rem] leading-snug text-secondary m-0">
                            You won't be charged until
                            <span class="text-primary font-semibold">{{
                                getTrialEndDate() | date:'d MMMM yyyy'
                                }}</span>
                        </p>
                        <p class="text-sm leading-snug text-secondary m-0">Cancel anytime before then — no questions
                            asked</p>
                    </div>
                </div>
                <!-- Trial Card -->

                <!-- Subscription Summary Card -->
                <div
                    class="w-full max-w-lg card-container-pale flex flex-col divide-y space-y-2 divide-gray-100 dark:divide-white/10">
                    <div class="mb-0 p-2">
                        <h3 class="text-base font-semibold text-primary">Your Subscription</h3>
                        <p class="text-sm text-secondary">Here's what you're getting</p>
                    </div>
                    <div class="w-full flex flex-col gap-y-2 divide-y divide-gray-100 dark:divide-white/10">
                        @for (item of currentUserService.currentSubscription().items.data; track item.id) {
                        <div class="flex items-start gap-4 px-2 py-4">
                            <div class="shrink-0 w-10 h-10 rounded-lg bg-linear-to-br from-[#776fff] to-[#ff4694] flex items-center justify-center text-white"
                                aria-hidden="true">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="w-5 h-5">
                                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                                </svg>
                            </div>
                            <div class="min-w-0 flex-1">
                                <p class="text-base font-bold text-primary m-0 mb-0.5 leading-tight">{{
                                    item.price.product.name }}{{ item.price.product.name &&
                                    !subscriptionSummary().planName.toLowerCase().endsWith('plan') ? ' Plan' : '' }}</p>
                                <p class="text-sm font-normal text-gray-400 m-0 leading-snug">{{
                                    item.price.product.description }}</p>
                            </div>
                            <p class="shrink-0 text-sm font-normal text-gray-400 m-0">{{ item.price.unit_amount / 100 | currency: currentUserService.currentSubscription().currency.toUpperCase() }}/mo</p>
                        </div>
                        }
                    </div>

                    <div class="flex items-center justify-between gap-3 px-2 py-2">
                        <span class="text-sm font-normal text-gray-400">Total per month</span>
                        <span
                            class="text-lg font-bold bg-linear-to-br from-[#776fff] to-[#ff4694] bg-clip-text text-transparent">{{ getTotalPrice() | currency: currentUserService.currentSubscription().currency.toUpperCase() }}</span>
                    </div>
                </div>
                <!-- Subscription Summary Card - END -->

                <!-- What Next -->
                <section class="w-full max-w-lg text-left" aria-labelledby="what-next-heading">
                    <h2 id="what-next-heading" class="text-lg font-bold text-primary m-0 mb-6 leading-tight">What
                        happens next?</h2>
                    <ul class="list-none m-0 p-0 flex flex-col gap-6">
                        <li class="flex items-start gap-4">
                            <span
                                class="shrink-0 w-11 h-11 rounded-full flex items-center justify-center bg-pink-600/20 text-pink-600"
                                aria-hidden="true">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="w-5 h-5 text-primary">
                                    <path
                                        d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
                                </svg>
                            </span>
                            <div class="min-w-0">
                                <p class="text-base font-bold text-primary m-0 mb-1 leading-tight">Create your first
                                    brief</p>
                                <p class="text-sm font-normal text-gray-400 m-0 leading-snug">Start matching with
                                    creators right away — no waiting required</p>
                            </div>
                        </li>
                        <li class="flex items-start gap-4">
                            <span
                                class="shrink-0 w-11 h-11 rounded-full flex items-center justify-center bg-teal-600/20 text-teal-600"
                                aria-hidden="true">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="w-5 h-5 text-primary">
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="M12 6v6l4 2" />
                                </svg>
                            </span>
                            <div class="min-w-0">
                                <p class="text-base font-bold text-primary m-0 mb-1 leading-tight">14 days to explore
                                </p>
                                <p class="text-sm font-normal text-gray-400 m-0 leading-snug">Try everything risk-free.
                                    Cancel anytime before {{
                                    currentUserService.currentSubscription()?.current_period_end | date:'d MMMM yyyy' }}
                                </p>
                            </div>
                        </li>
                    </ul>
                </section>
                <!-- What Next - END -->

                <!-- Get Started -->
                <div class="w-full flex flex-col items-center gap-5">
                    <a routerLink="/dashboard" class="w-full max-w-lg flashy-go-button no-underline">
                        Get Started
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            aria-hidden="true" class="shrink-0">
                            <path d="M5 12h14" />
                            <path d="m12 5 7 7-7 7" />
                        </svg>
                    </a>
                    <p class="m-0 text-sm font-normal text-center text-[#b4aec4]">
                        Questions? <a href="mailto:hello@shoutugc.com"
                            class="text-[#a78bfa] no-underline font-normal hover:underline">Contact our team</a>
                    </p>
                </div>
                <!-- Get Started - END -->
                }

            </div>
        </div>

        <div aria-hidden="true"
            class="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:-top-112 sm:ml-16 sm:translate-x-0">
            <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                class="aspect-1097/845 w-274.25 bg-linear-to-tr from-[#ff4694] to-[#776fff] opacity-20"></div>
        </div>
    </div>
</div>